import React,{ useState,useEffect,lazy,Suspense  } from "react";
import axios from "axios";
import mqtt from "mqtt";
import { requestForToken } from "../../components/firebase";
import { insertDataInLocalDb } from "../../store";
import 'react-notifications-component/dist/theme.css'
import * as serviceWorkerRegistration from '../../serviceWorkerRegistration';
import { ReactNotifications,Store } from 'react-notifications-component';
import PWAInstallBanner from "../../components/PWAInstallBanner";
const TopHeader = lazy(() => import("../../components/TopHeader/HomeHeader"))
const LeftMenu = lazy(() => import("../../components/LeftMenu"))
const HomeTabs = lazy(() => import("../../components/HomeTabs"))
const Profile = lazy(() => import("../../components/Profile"))
const Accounts = lazy(() => import("../../components/Accounts"))
//const Channels = lazy(() => import("../../components/Channels"))
//const AddFund = lazy(() => import("../../components/AddFund"))
//const AdsViewers = lazy(() => import("../../components/AdsViewers"))
//const Tutorial = lazy(() => import("../../components/Tutorial"))
//const Addlession = lazy(() => import("../../components/Addlession"))
//const SelectMembers = lazy(() => import("../../components/SelectMembers"))
const BCSelectMembers = lazy(() => import("../../components/SelectMembers/Broadcast/SelectMembers"))
//const VCSelectMembers = lazy(() => import("../../components/SelectMembers/VideoConf/SelectMembers"))
//const AddMembers = lazy(() => import("../../components/AddMembers"))
//const CreateTambola = lazy(() => import("../../components/CreateTambola"))
//const CreateAd = lazy(() => import("../../components/CreateAd"))
const CreateBroadcast = lazy(() => import("../../components/Modal/CreateBroadcast"))
const CreateGroup = lazy(() => import("../../components/CreateGroup"))
const WapGroup = lazy(() => import("../../components/WapGroup"))
const UploadMedia = lazy(() => import("../../components/UploadMedia")) 
//const GameInfo = lazy(() => import("../../components/GameInfo")) 
const GroupMembers = lazy(() => import("../../components/GroupMembers"))   
const BCReport = lazy(() => import("../../components/BCReport"))   
//const RedemPoints = lazy(() => import("../../components/RedemPoints"))   
//const New = lazy(() => import("../../pages/New"))
const GameView = lazy(() => import("../../pages/GameView"))
const CompletedInner = lazy(() => import("../../pages/CompletedInner"))
const Broadcastreport = lazy(() => import("../../pages/Communication/Broadcast/Broadcastreport"))
//const VideoConfList = lazy(() => import("../../pages/Communication/VideoConf/VideoConfList"))

const API_PATH="https://brsinbox.com/API/";

const apiUrl_vc = API_PATH+"evoltest_vc.php";
const loginUserId=localStorage.getItem('_tm_luId');
const loginOwnerId=localStorage.getItem('_tm_laccId');
const mno_1=localStorage.getItem('_tm_lmno');
const mqttUrl = 'wss://cast.spearuc.com:8084/mqtt';
const mqttClientId = "speardroid-"+ Math.random().toString(16).substring(2, 8);
const mqttOptions = {
clean: true,
connectTimeout: 10000,
clientId: mqttClientId,
username: 'spearucweb',
password: 'SKogDxEPFMN4b7d',
}

var _inx_version_local=localStorage.getItem("_inx_version_spearUp_tambola");
if(loginOwnerId>0 && loginUserId>0 && loginOwnerId!=="-" && typeof _inx_version_local !== "undefined"){
	
	const isSupported = () =>
	'Notification' in window &&
	'serviceWorker' in navigator &&
	'PushManager' in window

	if (isSupported()) {
		const hasPermission = Notification.permission === 'granted'
		//alert(hasPermission);
		if(hasPermission){
		 requestForToken();
		}else{
			if (Notification.permission === "granted") {
			// Permissions already granted, no need to alert for settings
			// You can proceed to send notifications
			} else if (Notification.permission === "denied") {
			  alert("Notification permissions are currently denied. Please enable them in your browser settings to receive alerts.");
			     console.log("Notification permissions are currently denied. Please enable them in your browser settings to receive alerts."); 
					  
				 /*  Store.addNotification({
						title: "Notification",
						message: "Notification permissions are currently denied. Please enable them in your browser settings to receive alerts.",
						type: "success",
						insert: "top",
						container: "top-right",
						animationIn: ["animate__animated", "animate__fadeIn"],
						animationOut: ["animate__animated", "animate__fadeOut"],
						dismiss: {
						duration: 1000,
						onScreen: true
						}
						}); */
							
			  
			} else if (Notification.permission === "default") {
				// Permission not yet requested or user hasn't made a choice
				// You can prompt the user to grant permission
				Notification.requestPermission().then((permission) => {
					if (permission === "granted") {
					 // User granted permission
					} else if (permission === "denied") {
					  // alert("Notification permissions denied. Please enable them in your browser settings."); 
					   console.log("Notification permissions denied. Please enable them in your browser settings."); 
					   /* 
					   Store.addNotification({
							title: "Notification",
							message: "Notification permissions denied. Please enable them in your browser settings.",
							type: "success",
							insert: "top",
							container: "top-right",
							animationIn: ["animate__animated", "animate__fadeIn"],
							animationOut: ["animate__animated", "animate__fadeOut"],
							dismiss: {
							duration: 1000,
							onScreen: true 
							}
							}); */  
					}
				});
			}else{
				console.log("Hi NOT there 2!");
			}
		}
	}

}
function closeLSPGE(){
	const searchWord="_PGE";
	for (const key of Object.keys(localStorage)) {
		if (key.includes(searchWord)) {	
		  localStorage.setItem(key,"C");
		}
	}
}
export const Home = () => {
	const [campaignInfo, setCampaignInfo] = useState(false);
	const [collapsed, setCollapsed] = useState(true);
	const toggleSidebar = () => {
	setCollapsed(prev => !prev);
	};

	localStorage.setItem('_tm_groupIdsSet',"");
	localStorage.setItem('_tm_pcIdsSet',"");
	localStorage.setItem('_tm_empIdsSet',"");
	localStorage.setItem('_tm_numberSet',"");
	
	localStorage.setItem('_tm_groupIdsSet_2',"");
	localStorage.setItem('_tm_numberSet_2',"");
	localStorage.setItem('_tm_empIdsSet_2',"");
	localStorage.setItem('_tm_pcIdsSet_2',"");
	
	localStorage.setItem('_tm_pcIdsSet_4',"");
	localStorage.setItem('_tm_numberSet_4',"");
	localStorage.setItem('_tm_empIdsSet_4',"");
	
	  const sentDeliveryReceipt = async (info24) => {
		    
			var responseData_Obj124 = JSON.parse(info24);
		 	let updated_responseData_Obj124 =  { ...responseData_Obj124, fcmStatus: "1", fcmStatusDs:"Delivered" }; 
			if(updated_responseData_Obj124){ 
				if(typeof updated_responseData_Obj124 === "object" && updated_responseData_Obj124 && "campaignId" in updated_responseData_Obj124 && typeof updated_responseData_Obj124.campaignId === "string"){
					insertDataInLocalDb(updated_responseData_Obj124,'_historyApi',updated_responseData_Obj124.campaignId)
				} 
			} 
			const cellData61={
						 api4m:"1",
						 ucUserId:loginUserId,
						 accountId:loginOwnerId,
						 callStatus:"1",
						 accountOwnerId:"2328",
						 campaignTypeId:"5",
						 campaignId:responseData_Obj124.campaignId,
						 mobileNo:mno_1,
						 fnRowId:responseData_Obj124.campaignId,
						 deliveryMode:2,
						 readPercent:0
					}
		    const topicStr="/topics/spearon_mmr1";
			const mqttClient  = mqtt.connect(mqttUrl, mqttOptions)
			mqttClient.on('connect', function () {
					console.log('Connected')
					mqttClient.subscribe(topicStr, function (err) {
						if (!err) {
							console.log('subscribe to topics/spearon_mmr1')
							mqttClient.publish(topicStr, JSON.stringify(cellData61))
							mqttClient.end(false, () => {
							console.log('mqtt disconnected successfully')
							})
						}else{
						   console.log('NOT Connected!!!')
						}
					})
			})
	};
	const callAppTrack = async (ac,pn,info,t_type) => {
		const payload4 = {
		  mno: pn,
		  ownerId: ac,
		  info: info,
		  t_type: t_type,
		};
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
		axios
		  .post(API_PATH+"api/app_track.php",payload4)
		  .then((response) => {
			//console.log("Response Data:", response.data);
		  })
		  .catch((error) => {
			console.log(error);
		  });
	}  
   useEffect(() => {
	closeLSPGE();
	const videoLR24 = document.querySelector("video");
	if(videoLR24){
		videoLR24.pause();
		videoLR24.currentTime = 0;
	}
	
	navigator.serviceWorker.addEventListener("message", (message) =>{	

		const cellData220=message.data;	
		if(typeof cellData220 === "string"){
			console.log('string'); 
			const cellData22=JSON.parse(cellData220);
			//console.log(cellData22);
			var moduleId2=cellData22.module;
			if(moduleId2 === "smsplus"){ moduleId2=27; }
			if(moduleId2 === 1008 || moduleId2 === "1008"){
				//window.location.reload();
			}else{
				sentDeliveryReceipt(cellData220)
			  //console.log(moduleId2);
			}
		}else{ 
			//console.log('message');
			const cellData22=message.data;	
			//const cellData2222=JSON.stringify(cellData22);	
			//console.log(cellData22.data.custom_data); 
			var custom_cell_data = JSON.parse(cellData22.data.custom_data);
			//console.log(custom_cell_data);
			var moduleId=custom_cell_data.module?custom_cell_data.module:11; 
			//console.log('moduleId');
			if(moduleId === "smsplus"){ moduleId=27; }
			const cellData12 = custom_cell_data.payload;
			if(moduleId === 1008 || moduleId === "1008"){
				//window.location.reload();
			}else{
				
				let cellData12_22 =  { ...cellData12, fcmStatus: "1", fcmStatusDs:"Delivered" }; 
				if(typeof cellData12_22 === "object" && cellData12_22 && "campaignId" in cellData12_22 && typeof cellData12_22.campaignId === "string"){
					
					 insertDataInLocalDb(cellData12_22,'_historyApi',cellData12_22.campaignId)
					 console.log("Updated Row");
				} 	
			}
		}
	}); 
			 
	 /* setInterval(() => {
		getGroupList();
	 }, 150000);  */
	
    const alertMessage = () => {
		closeLSPGE();
		const dfd=localStorage.getItem('_tm_camp_info');
		setCampaignInfo(dfd);
    }
    window.addEventListener('custom-storage-event-campaignInfo', alertMessage);
    //Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("custom-storage-event-campaignInfo", alertMessage);
    }
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
/*   useEffect(() => {
	  
		window.history.pushState(null, "", window.location.href);

		const handleBackButtonHome = (event) => {
			event.preventDefault();
			//alert("HOME");
			const searchWord="_PGE";
			let innerPGE="N";
			let allItems = "";
			for (const key of Object.keys(localStorage)) {
				if (key.includes(searchWord)) {	
				  allItems = localStorage.getItem(key);
				  if(allItems === "O"){   
				        innerPGE="Y";
				  }
				}
			}
			if(innerPGE === "N"){
				window.removeEventListener("popstate", handleBackButtonHome);
				window.history.back();
			}
	   }; 

	window.addEventListener("popstate", handleBackButtonHome);
	return () => window.removeEventListener("popstate", handleBackButtonHome);
	}, []); */
	
	useEffect(() => {
	  serviceWorkerRegistration.register({
		onUpdate: registration => {
		  console.log("🔄 New service worker found");

		  const waitingSW = registration.waiting;

		  if (waitingSW) {
			waitingSW.postMessage({ type: "SKIP_WAITING" });

			waitingSW.addEventListener("statechange", () => {
			  if (waitingSW.state === "activated") {
				console.log("✅ New version activated");
				//window.location.reload();
			  }
			});
		  }
		},
	  });
	}, []);

	
	useEffect(() => {
	  if ("serviceWorker" in navigator) {
		navigator.serviceWorker.addEventListener("controllerchange", () => {
		  console.log("🚀 App updated");
		  //window.location.reload();
		});
	  }
	}, []);

	useEffect(() => {
	if (!loginOwnerId || !loginUserId) return;
	callAppTrack(loginOwnerId,mno_1,loginUserId,4);  
	const checkAppVersion = async () => {
		
	try {
	  const { data: serverVersion } = await axios.post(apiUrl_vc, {
		accId: loginOwnerId,
		uId: loginUserId,
	  });

	  if (!serverVersion) return;

	  const localVersion =
		localStorage.getItem("_inx_version_spearUp_tambola");

	  if (String(serverVersion) !== String(localVersion)) {
		console.log("🔄 New app version detected");

		localStorage.setItem(
		  "_inx_version_spearUp_tambola",
		  serverVersion
		);

		const registration =
		  await navigator.serviceWorker.getRegistration();

		if (registration) {
		  registration.update(); // ✅ CORRECT UPDATE
		}
	  }
	} catch (err) {
	  console.error("Version check failed", err);
	}
	};

	checkAppVersion();
	}, []);
	
	useEffect(() => {
	  const isStandalone =
		window.matchMedia("(display-mode: standalone)").matches ||
		window.navigator.standalone === true;

	  // 🚨 App is NOT installed → reset dismissal
	  if (!isStandalone) {
		localStorage.removeItem("pwa_install_dismissed");
	  }
	}, []);
	
    return (
	    <>
		<PWAInstallBanner />
		<Suspense fallback={<div className="loader">Loading...</div>}>
        <div className="row nomarpad">
		<TopHeader onToggle={toggleSidebar} collapsed={collapsed}/>
	    <div className="body_container">  <div className="leftnav" id="body-row">
		<LeftMenu onToggle={toggleSidebar} collapsed={collapsed} />
		  <main className="col fluid d-flex flex-column p-0 rightbox_main" style={{background:"#FFFFFF"}} >
          <div className="row nomarpad">
            <div className="col-lg-3 body_left_main" id="body_left_main">
             <HomeTabs/>
			  <div className="tab-content" id="myTabContent">
               {/* <New /> */}
                <Broadcastreport />
                {/*<VideoConfList /> */}
               </div>
			   </div>
			 <GameView/>
			 <CompletedInner/>
			 </div>
		  </main>
	    </div>
		</div>
		<div className="pre-toolbar" style={{ display: "none" }}>
		pretoolbar-content
		</div>
	    </div>
		{/*<TambolaDashboard/> */}
		{/* <AddMembers/>*/}
	    {/*<SelectMembers/> */}
	    <BCSelectMembers/>
	    {/*<VCSelectMembers/>
	    <CreateTambola/>*/}
	    {/*<CreateAd/>*/}
	    <CreateBroadcast/>
	    <CreateGroup/>
	    <WapGroup/>
	    <UploadMedia />
	    <GroupMembers/>
	    <BCReport/>
	    <Profile/>
	    <Accounts/>
	  {/* <Addlession/>
	    <Tutorial/>
	    <Channels/>
		<GameInfo info={campaignInfo}/>
		<RedemPoints/>
	    <AddFund/>
	   <AdsViewers/>/*/}
		<ReactNotifications />
		</Suspense>
		</>
    );
};

export default Home;
